import React, { useState, useEffect } from 'react';
import SitePageBody from '../components/common/SitePageBody';
import { useBranding } from '../context/BrandingContext';
import { getSitePage } from '../services/api';
import SEO from '../components/SEO';
import FroggySpinner from '../components/common/FroggySpinner';
import { CORE_KEYWORDS } from '../constants/seoKeywords';

export default function FAQPage() {
  const { template } = useBranding();
  const [content, setContent] = useState(null);
  const [title, setTitle] = useState('Frequently Asked Questions');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  const supportEmail = template?.footerLinks?.find(link => link.label === 'Support')?.href?.replace('mailto:', '') || 'support@feelingfroggy.llc';

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const data = await getSitePage('faq');
        setContent(data.content_md);
        setTitle(data.title);
        setError(false);
      } catch (err) {
        console.error('Failed to fetch FAQ content:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="page-container" style={{ textAlign: 'center', padding: 'var(--ff-space-5xl) 0' }}>
        <FroggySpinner size="lg" label="Loading FAQ" />
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="page-container">
        <h1 className="ff-heading-h1" style={{ marginBottom: 'var(--ff-space-xl)', textAlign: 'center' }}>Frequently Asked Questions</h1>
        <p>This content is temporarily unavailable. Please try again later.</p>
      </div>
    );
  }

  return (
    <>
      <SEO
        title="FAQ - Frequently Asked Questions"
        description="Common questions about dart frogs, shipping, care, and ordering from Feeling Froggy. Find answers about our live arrival guarantee, frog care, and vivarium supplies."
        canonical="https://feelingfroggy.llc/faq"
        keywords={CORE_KEYWORDS}
      />
      <div className="page-container">
        <h1 className="ff-heading-h1" style={{ marginBottom: 'var(--ff-space-xl)', textAlign: 'center' }}>{title}</h1>
        <SitePageBody className="faq-content" title={title} content={content} />
      </div>
    </>
  );
}